import React from "react";
import { ZOOM } from "./config";

function clampZoom(value) {
  return Math.max(ZOOM.minimum, Math.min(ZOOM.maximum, value));
}

export default function TimelineZoomControls({ onChange, zoom }) {
  const percentage = Math.round(zoom * 100);

  return (
    <div className="history-chart__zoom" aria-label="Timeline zoom controls">
      <p className="history-chart__pan-hint" id="history-chart-pan-hint">
        Drag the chart sideways to move along the years, or focus it and use the arrow keys.
      </p>
      <button
        type="button"
        onClick={() => onChange(clampZoom(zoom - ZOOM.step))}
        disabled={zoom <= ZOOM.minimum}
        data-testid="history-zoom-out"
      >
        Zoom out
      </button>
      <button
        type="button"
        onClick={() => onChange(ZOOM.fit)}
        disabled={zoom === ZOOM.fit}
        data-testid="history-zoom-fit"
      >
        Fit
      </button>
      <button
        type="button"
        onClick={() => onChange(clampZoom(zoom + ZOOM.step))}
        disabled={zoom >= ZOOM.maximum}
        data-testid="history-zoom-in"
      >
        Zoom in
      </button>
      <output className="history-chart__zoom-value" aria-live="polite">
        {percentage}%
      </output>
    </div>
  );
}
